import environment from "src/utils/environment";
import protoRoot from "../proto-root";

function getData() {
  if (environment.isBrowser) {
    return {
      platform: "browser"
    };
  }
  const { app } = window.require("@electron/remote");
  return {
    version: app.getVersion(),
    build: app.getVersion().split("-")[0].replace(/\./g, ""),
    platform: "electron"
  };
}

function create() {
  const DataBuildInformation = protoRoot.lookupType(
    "comm.DataBuildInformation"
  );

  const dataBuildInformation = DataBuildInformation.create(getData());
  return dataBuildInformation;
}

export default {
  create
};
